import { apiService } from "@/core/services";

export const DEV_OPS = {
  getAccountName,
  createAccount,
  updateAccount,
  deleteAccount,
};

const URL = {
  ALI: "ali",
  LOAD_ALL_ACCOUNTS: "load-all-accounts",
  CREATE_RESOURCE_ACCOUNTS: "create-resource-accounts",
};

function getAccountName() {
  return apiService().get(`/${URL.ALI}/${URL.LOAD_ALL_ACCOUNTS}`);
}

function createAccount(data) {
  const resourceName = (data) => {
    let businessUnitName = data.businessUnit.name.substring(0, 1).toLowerCase();
    let region = data.regionShortName;
    let environment = data.environment.toLowerCase();
    let appName = data.appName.toLowerCase();
    let name = `${businessUnitName}-${region}-${environment}-${appName}`;
    return name;
  };

  const getSubnet1 = (data) => {
    let subnet = [];
    subnet = data.map((x) => {
      if (x.no <= 3) {
        if (x.iPv4 && x.iPv4a) {
          return `${x.iPv4}/${x.iPv4a}`;
        }
      }
    });
    subnet = subnet.filter((x) => x !== undefined);
    return subnet.toString();
  };

  const getSubnet2 = (data) => {
    let subnet = [];
    subnet = data.map((x) => {
      if (x.no > 3) {
        if (x.iPv4 && x.iPv4a) {
          return `${x.iPv4}/${x.iPv4a}`;
        }
      }
    });
    subnet = subnet.filter((x) => x !== undefined);
    return subnet.toString();
  };

  const getAvailabilityZone = (data) => {
    let availabilityZone = [];
    availabilityZone = data.map((x) => x.availability);
    availabilityZone = availabilityZone.filter((x) => {
      return x !== null;
    });
    return availabilityZone.toString();
  };

  let requestBody = {
    l1Dir: data.publicHybrid.value,
    l1DirName: data.publicHybrid.name,
    businessUnitName: data.businessUnit.name,
    availabilityZone: getAvailabilityZone(data.subnet),
    businessUnit: data.businessUnit.value,
    appname: data.appName,
    appnameDir: data.appName,
    accountNames: data.accountName,
    environment: data.environment,
    region: data.region.toLowerCase(),
    resourceName: resourceName(data),
    appOwner: data.appOwner,
    costCenter: data.costCenter,
    fullname: data.appFullName,
    subnet1: getSubnet1(data.subnet),
    subnet2: getSubnet2(data.subnet),
  };
  return apiService().post(
    `/${URL.ALI}/${URL.CREATE_RESOURCE_ACCOUNTS}`,
    requestBody
  );
}
function updateAccount(id, data) {
  let requestBody = { data };
  return apiService().put(
    `/${URL.ALI}/${URL.PERMISSION}/${URL.UPDATE}/${id}`,
    requestBody
  );
}
function deleteAccount(id) {
  return apiService().delete(
    `/${URL.ALI}/${URL.PERMISSION}/${URL.DELETE}/${id}`
  );
}
